export default {
  "title": "Academia",
  "subtitle": "Campamentos, programas y talleres",
  "explore": "Explorar",
  "myBookings": "Mis reservas",
  "search": "Buscar programas",
  "category": "Categoría",
  "allCategories": "Todas las categorías",
  "date": "Fecha",
  "details": "Detalles del programa",
  "book": "Reservar",
  "waiting": "Unirse a la lista de espera",
  "participants": "Participantes y fechas",
  "summary": "Consentimiento y resumen",
  "payment": "Pago",
  "confirm": "Confirmar reserva",
  "continue": "Continuar",
  "back": "Volver",
  "consent": "Acepto estas condiciones para cada participante seleccionado y confirmo mi autoridad para reservar.",
  "total": "Total",
  "net": "Neto",
  "tax": "Impuesto",
  "free": "Gratis",
  "member_account": "Cargar en mi cuenta de socio",
  "cash": "Efectivo recibido por el club",
  "card": "Pagar con tarjeta",
  "cancel": "Cancelar reserva",
  "cancelReason": "Motivo de cancelación",
  "confirmed": "Reserva confirmada",
  "held": "Plaza retenida: participación sin confirmar",
  "expired": "Retención caducada",
  "cancelled": "Cancelada",
  "payment_attention": "El pago requiere atención",
  "pending": "Pendiente",
  "paid": "Pagado",
  "on_account": "Cargado en la cuenta de socio",
  "none": "No requiere pago",
  "refund_pending": "Reembolso pendiente",
  "refund_failed": "Reembolso fallido",
  "refunded": "Reembolsado",
  "terms": "Condiciones",
  "eligibility": "Elegibilidad",
  "prerequisite": "Requisito previo",
  "venue": "Lugar",
  "schedule": "Horario",
  "price": "Precio por participante",
  "availability": "Plazas disponibles",
  "noProgrammes": "Ningún programa coincide con tus filtros.",
  "noBookings": "No tienes reservas de Academia.",
  "loading": "Cargando Academia…",
  "retry": "Reintentar",
  "error": "No se pudo completar la acción. Inténtalo de nuevo.",
  "unavailable": "El pago con tarjeta no está disponible hasta que el club configure el proveedor.",
  "reference": "Referencia de reserva",
  "self": "Titular",
  "dependant": "Dependiente",
  "accept": "Aceptar oferta",
  "decline": "Rechazar / salir de la lista",
  "offered": "Plaza ofrecida",
  "waitingStatus": "En espera",
  "accepted": "Aceptada",
  "declined": "Rechazada",
  "offering": "Convocatoria",
  "configure": "Configuración de reservas de socios",
  "assisted": "Reserva asistida",
  "guardianReview": "Revisión de autoridad del tutor",
  "guardian": "Socio tutor",
  "payer": "Pagador / autor de la reserva",
  "approve": "Aprobar autoridad del tutor",
  "reason": "Motivo de revisión",
  "save": "Publicar política para socios",
  "description": "Descripción para socios",
  "image": "URL de imagen",
  "categoryLabel": "Categoría",
  "termsLabel": "Condiciones de consentimiento y cancelación",
  "visible": "Visible para socios",
  "selectedDays": "Permitir días seleccionados",
  "accountCharge": "Permitir cargos en cuenta de socio",
  "cashEnabled": "Permitir pagos en efectivo al club",
  "cardEnabled": "Permitir pago con tarjeta configurado",
  "refundEnabled": "Reembolsable antes del plazo de cancelación",
  "cancellationHours": "Plazo de cancelación (horas antes del inicio)",
  "minAge": "Edad mínima (opcional)",
  "maxAge": "Edad máxima (opcional)",
  "taxCode": "ID de código fiscal",
  "mapping": "Clave de asignación de ingresos",
  "bookingOpen": "Apertura de reservas",
  "bookingClose": "Cierre de reservas",
  "history": "Historial de reservas",
  "refresh": "Actualizar",
  "selectOffering": "Seleccionar convocatoria",
  "allOrNothing": "Los participantes reservan y cancelan en grupo. Los días seleccionados usan el precio publicado del programa.",
  "startCheckout": "Abrir pago seguro",
  "resume": "Reanudar pago",
  "age_unknown": "El club necesita la fecha de nacimiento para comprobar la elegibilidad.",
  "age_ineligible": "El participante está fuera del intervalo de edad configurado.",
  "prerequisite_required": "El participante no cumple el requisito previo.",
  "guardian_authority_required": "Se requiere autoridad de tutor aprobada.",
  "terms_changed": "Las condiciones han cambiado. Revisa el programa actual antes de continuar.",
  "payer_authority_required": "No tienes autorización para cargar a este pagador.",
  "cancellation_deadline_passed": "Ha pasado el plazo de cancelación.",
  "occurrence_history_locked": "La sesión ha comenzado o tiene registros de asistencia.",
  "offering_full": "El programa está completo. Únete a la lista de espera.",
  "already_enrolled": "Un participante ya tiene plaza o está en la lista de espera.",
  "offering_not_ready": "El programa ya no admite reservas.",
  "booking_closed": "El periodo de reserva está cerrado.",
  "member_account_required": "Se requiere una cuenta de socio activa.",
  "currency_unconfigured": "El club debe configurar su moneda.",
  "tax_code_required": "El club debe configurar un código fiscal activo.",
  "payment_method_unavailable": "Este método de pago no está disponible.",
  "idempotency_conflict": "La solicitud ha cambiado. Inicia una nueva reserva.",
  "forbidden": "No tienes permiso para esta acción.",
  "credit_limit_exceeded": "La compra supera el límite de crédito de la cuenta.",
  "consent_required": "Acepta las condiciones antes de confirmar.",
  "places_available": "Hay plazas disponibles; reserva directamente.",
  "offer_expired": "La oferta ha caducado.",
  "events": {
    "enrolment_confirmed": "Reserva de Academia confirmada",
    "enrolment_cancelled": "Reserva de Academia cancelada",
    "waiting_joined": "Inscripción en lista de espera de Academia",
    "place_offered": "Oferta de plaza de Academia",
    "place_offer_expired": "Oferta de plaza de Academia caducada",
    "waiting_declined": "Salida de lista de espera de Academia",
    "waiting_attention": "La lista de espera de Academia requiere revisión",
    "schedule_changed": "Horario de Academia modificado",
    "attendance_recorded": "Asistencia de Academia registrada",
    "attendance_corrected": "Asistencia de Academia corregida",
    "payment_attention": "El pago de Academia requiere atención",
    "refund_completed": "Reembolso de Academia completado",
    "reminder": "Recordatorio de reserva de Academia"
  },
  "cancelOffering": "Cancelar convocatoria futura y recuperar pagos",
  "nonMemberDependant": "Nombre del dependiente no socio",
  "dateOfBirth": "Fecha de nacimiento",
  "createDependant": "Crear dependiente revisado",
  "upcoming": "Próximas",
  "past": "Pasadas",
  "attention": "Atención financiera",
  "reconcile": "Conciliar estado del proveedor",
  "cashRefund": "Confirmar reembolso en efectivo pagado",
  "retryRefund": "Reintentar reembolso fallido",
  "cash_refund_confirmation_required": "Confirma que se ha pagado el reembolso en efectivo.",
  "refund_not_retryable": "El proveedor no ha confirmado un fallo definitivo del reembolso.",
  "accountCredited": "Crédito aplicado a la cuenta de socio",
  "staff_scope_required": "Se requiere permiso explícito para inscribir empleados.",
  "nonMemberParticipant": "Dependiente sin afiliación",
  "personSearch": "Buscar socio o empleado",
  "employee": "Empleado",
  "member": "Socio",
  "employeePayerReview": "Autoridad del pagador del empleado",
  "employeePayerGuidance": "Las plazas de pago para empleados requieren autorización revisada del socio pagador seleccionado. El empleo no otorga acceso a cuentas.",
  "approvePayer": "Aprobar autoridad explícita del pagador",
  "bookingActorMember": "Autor de la reserva / contacto socio",
  "payerMember": "Pagador autorizado",
  "assistingStaff": "Personal asistente: el operador del club autenticado.",
  "clubStaffActor": "Autor del personal del club (grupos de empleados)",
  "noPayerFreeStaff": "Sin socio pagador (grupo gratuito de empleados)",
  "selectedOccurrences": "Sesiones seleccionadas",
  "clubLocalWindows": "Periodo de reservas en hora del club",
  "club_timezone_required": "El club debe configurar una zona horaria IANA válida.",
  "invalid_local_time": "Esta hora local del club no es válida o coincide con un salto de horario de verano. Elige otra hora.",
  "ambiguous_local_time": "Esta hora local del club ocurre dos veces al cambiar los relojes. Elige una hora inequívoca.",
  "invalid_booking_window": "El cierre de reservas debe ser posterior a la apertura.",
  "waitingManagement": "Listas de espera y ofertas",
  "sequence": "Orden de llegada",
  "priority": "Prioridad auditada",
  "offerDeadline": "Plazo de la oferta",
  "inspectWaiting": "Consultar grupo en espera",
  "waitingDetail": "Detalles del grupo en espera",
  "prepareOffer": "Revisar oferta de plaza",
  "acceptOnBehalf": "Aceptar oferta en representación",
  "declineOnBehalf": "Rechazar / salir en representación",
  "overridePriority": "Guardar modificación de prioridad auditada"
};
